import React, { useMemo, useState } from 'react'
import { Col, Container, Row, Stack } from 'react-bootstrap'
import { Button } from '../../../../components/Button/Button'
import { ScopedBlock } from '../../../../components/ScopedBlock/ScopedBlock'
import { MissingScopeAction } from '../../../../components/ScopedBlock/models'
import { useAppSelector } from '../../../../store/hooks'
import { selectAccountId } from '../../../../store/auth/authSlice'
import { useDeleteUserIntegrationMutation, useGetMeQuery } from '../../../../store/user/user'
import { IntegrationServiceId } from '../../../../common/integrations'
import { IntegrationIcon } from '../../../../components/IntegrationIcon'
import { ExchangeCredentialsModal } from '../../../Integration/Connectors/ModalIntegrationConnectors/Exchange/ExchangeCredentialsModal'

export type ExchangeCalendarIntegrationRowProps = {}

export const ExchangeCalendarIntegrationRow: React.FC<ExchangeCalendarIntegrationRowProps> = () => {
  const accountId = useAppSelector(selectAccountId)
  const { data: userData } = useGetMeQuery({ accountId: accountId }, { refetchOnMountOrArgChange: true })
  const [deleteUserIntegration, { isLoading: isDeletingIntegration }] = useDeleteUserIntegrationMutation()
  const [showExchangeCredentialsModal, setShowExchangeCredentialsModal] = useState<boolean>(false)

  const hasExchangeCalendarIntegration = useMemo(() => {
    return !!(userData && userData.integrations && userData.integrations.some((i) => i.serviceId === IntegrationServiceId.EXCHANGE_CALENDAR))
  }, [userData])

  const uninstallExchangeCalendar = () => {
    if (!userData) {
      return
    }
    const integration = userData.integrations?.find((i) => i.serviceId === IntegrationServiceId.EXCHANGE_CALENDAR)
    if (!integration) {
      return
    }
    deleteUserIntegration({
      accountId,
      payload: {
        userId: userData.id,
        integrationId: integration.id,
      },
    })
  }

  const handleConnect = () => {
    setShowExchangeCredentialsModal(true)
  }

  const handleOnSave = () => {
    setShowExchangeCredentialsModal(false)
  }

  return (
    <Container className='p-3 p-md-0 py-md-3 integration-container'>
      <ExchangeCredentialsModal show={showExchangeCredentialsModal} onSave={handleOnSave} onCancel={() => setShowExchangeCredentialsModal(false)} />
      <Row className='d-flex justify-content-between'>
        <Col>
          <Stack direction='horizontal' className='gap-4 pb-4 pb-md-0'>
            <div className='rounded py-1 px-1 zocks-bg-color-gray-100'>
              <IntegrationIcon serviceId={IntegrationServiceId.EXCHANGE_CALENDAR} width={48} height={48} />
            </div>
            <div>
              <h6>Exchange Calendar (On-Premise)</h6>
              <div>
                Sync Exchange Calendar events so that Zocks joins your calls automatically. <br />
              </div>
            </div>
          </Stack>
        </Col>
        <Col md='auto'>
          <Stack direction='horizontal' className='gap-3 align-items-start'>
            <div className='connect-button-container'>
              {hasExchangeCalendarIntegration ? (
                <div className='connect-button-container'>
                  <Button variant='primary' onClick={uninstallExchangeCalendar} loading={isDeletingIntegration}>
                    Disconnect
                  </Button>
                  <div className='pt-2 d-flex justify-content-end zocks-text-success'>
                    <i className='bi bi-check' />
                    Connected
                  </div>
                </div>
              ) : (
                <ScopedBlock
                  scope={{
                    scope: 'integration:connect',
                    superScope: ['integration:admin'],
                  }}
                  missingScopeAction={MissingScopeAction.DISABLE}
                >
                  <Button variant='primary' onClick={handleConnect}>
                    Connect
                  </Button>
                </ScopedBlock>
              )}
            </div>
          </Stack>
        </Col>
      </Row>
    </Container>
  )
}
